export default [
  {
    path: '/prize-wheels',
    name: 'prizeWheels',
    component: () => import('@/views/menu/prizeWheel/prizeWheels.vue'),
    meta: {
      pageTitle: 'گردونه های شانس',
      action: 'show',
      resource: 'PrizeWheelManager',
    },
  },
  {
    path: '/prize-wheel-users',
    name: 'prizeWheelUsers',
    component: () => import('@/views/menu/prizeWheel/prizeWheelUsers.vue'),
    meta: {
      pageTitle: 'برندگان گردونه شانس',
      action: 'show',
      resource: 'PrizeWheelManager',
    },
  },
  {
    path: '/prize-wheels/add',
    name: 'addPrizeWheel',
    component: () => import('@/views/menu/prizeWheel/prizeWheelForm.vue'),
    meta: {
      pageTitle: 'ایجاد گردونه شانس جدید',
      action: 'show',
      resource: 'PrizeWheelManager',
    },
  },
  {
    path: '/prize-wheels/edit/:id',
    name: 'updatePrizeWheel',
    component: () => import('@/views/menu/prizeWheel/prizeWheelForm.vue'),
    meta: {
      pageTitle: 'ویرایش گردونه شانس',
      action: 'show',
      resource: 'PrizeWheelManager',
    },
  },

]